<template>
    <div v-if="!isClosed" class="notification_tool__container px-5 text-center">
        <p>{{ $t('lang.main.notification_tool_message') }}</p>
        <i class="pi pi-times cursor-pointer" @click="onClose"></i>
    </div>
</template>

<script>
import BrowserStorage from "../mixins/BrowserStorage";

export default {
    name: "NotificationTool",
    mixins: [BrowserStorage],
    data() {
        return {
            isClosed: true,
            storageKey: 'ks-notification-tool-08-10-closed',
        }
    },
    mounted() {
        this.isClosed = this.getLocalStorageItem(this.storageKey) ?? false;
    },
    methods: {
        onClose() {
            this.setLocalStorageItem(this.storageKey, true);
            this.isClosed = true;
        },
    }
}
</script>

<style scoped>
.notification_tool__container {
    position: relative;
    background-color: #7a8b98;
}
.notification_tool__container i,
.notification_tool__container p {
    color: #fff;
}
.notification_tool__container i {
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px;
}
</style>
